import React from 'react';
import { formatCountValue, formatMetricLabel } from './reportUtils';

/** Renders up to `max` KPI chips from a summary object (entries order preserved). */
const MiniKpiStrip = ({ summary, keys, max = 6, formatValue }) => {
  const s = summary && typeof summary === 'object' ? summary : {};
  const entries = keys ? keys.map((k) => [k, s[k]]) : Object.entries(s);
  const slice = entries.slice(0, max);
  return (
    <div className="sm-mini-kpi">
      {slice.map(([k, v]) => {
        let display;
        if (formatValue) {
          display = formatValue(k, v);
        } else if (typeof v === 'number' && Number.isFinite(v)) {
          display = formatCountValue(v);
        } else {
          display = v == null || v === '' ? '—' : String(v);
        }
        return (
          <div key={k} className="sm-mini-kpi__item">
            <div className="sm-mini-kpi__label">{formatMetricLabel(k)}</div>
            <div className="sm-mini-kpi__value">{display}</div>
          </div>
        );
      })}
    </div>
  );
};

export default MiniKpiStrip;
